import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest,
    ConfigurationIncidentsTypesLaboratoriesResponse
} from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.dto'

class IncidentsTypesLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationIncidentsTypesLaboratoriesResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationIncidentsTypesLaboratoriesResponse>>(`/configuration/laboratories/${laboratoryId}/incidentTypeLaboratories`, filterModel, { params })
        return response.data
    }

    async getIncidentsTypesLaboratoryById(laboratoryId: number, IncidentsTypesLaboratoryId: number): Promise<ConfigurationIncidentsTypesLaboratoriesResponse> {
        const response = await axios.get<ConfigurationIncidentsTypesLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentTypeLaboratories/${IncidentsTypesLaboratoryId}`)
        return response.data
    }

    async createIncidentsTypesLaboratory(laboratoryId: number, request: ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest): Promise<ConfigurationIncidentsTypesLaboratoriesResponse> {
        const response = await axios.post<ConfigurationIncidentsTypesLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentTypeLaboratories`, request)
        return response.data
    }

    async deleteIncidentsTypesLaboratory(laboratoryId: number, incidentTypeLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentTypeLaboratories/batch`, { data: incidentTypeLaboratoryIds })
        return response.data
    }

    async patchIncidentsTypesLaboratory(laboratoryId: number, requests: ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentTypeLaboratories/batch`, requests)
        return response.data
    }
}

export const incidentsTypesLaboratoriesConfigurationServices = new IncidentsTypesLaboratoriesConfigurationServices()
